export default __webpack_public_path__ + "static/media/ea03d30e43b3aa132cab5986df24da17.jpg";